export default "__VITE_ASSET__es71rKg6__"